import { OperationVariables, gql } from "@apollo/client";
import ICompanySettings, { ETimeSyncOption } from "@sharedInterfaces/ICompanySettings";
import Company from "@src/Objects/Company";

import GraphQL from "../graphQL";

import { companySettingsGql } from "./getCompanySettings";

const query = gql`
mutation setTimeSync( $timeSync: String!) {
    setTimeSync(timeSync: $timeSync) 
    ${companySettingsGql}
},
`;

export default async function setTimeSync(timeSync: ETimeSyncOption)
{
    const variables: OperationVariables = {
        timeSync
    };
    return GraphQL.mutate<ICompanySettings>(query, variables)
        .then(c => new Company(c))
}